<template>
    <!-- 文章详情 -->
    <div class="detail_container">
        <div class="detail_content_block">
            <span class="detail_title_text">{{ data.title }}</span>
            <span class="detail_date_text">{{ data.createdStr }}</span>
            <!-- <span class="detail_content_text">{{ data.content }}</span> -->
            <span class="detail_content_text" style="white-space:pre-wrap;">{{ data.content }}</span>

            <img :src="Cookie.get('apiUrl')+'/api/store/v0.1/read/'+data.imgs.split(',')[0]" alt="" v-if="data.imgs" class="row_right_img" @click="checkAllImg">
        </div>

        <div class="detail_mask_block" v-if="isShow">
            <div class="detail_mask_close" @click="closeAllImg">
                <i class="el-icon-close" style="font-size: 22px; color: white;"></i>
            </div>
            <div class="detail_mask_show">
                <img :src="Cookie.get('apiUrl')+'/api/store/v0.1/read/'+data.imgs.split(',')[0]" alt="" style="width: 100%; height: auto; display: block;">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            guid:'',
            data:{},
            isShow:false,
        }
    },
    mounted(){
        document.title='文章详情'
        this.guid = this.$route.query.guid
        this.$http.get('/api/ts/v0.1/article/read/'+this.guid)
        .then(res=>{
            console.log(res)
            if(res.status==200){
								this.data = res.data
								document.title = this.data.title
            }else{
                this.$message.error('查询失败！请联系管理员')
            }
        })
    },
    methods:{
        checkAllImg(){
            this.isShow = true
        },

        closeAllImg(){
            this.isShow = false
        },
    }
}
</script>
<style scoped>
    .detail_container{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
    }
    .detail_content_block{
        width: 100%;
        position: absolute;
        left: 0;
        top: 10px;
        bottom: 0;
        overflow-y: scroll;
        background-color: white;
        padding: 20px;
        box-sizing: border-box;
    }
    .detail_title_text{
        display: block;
        font-size: 16px;
        color: #333;
        font-weight: 700;
        text-align: left;
    }
    .detail_date_text{
        display: block;
        font-size: 14px;
        color: #666;
        text-align: left;
        margin-top: 8px;
    }
    .detail_content_text{
        display: block;
        font-size: 16px;
        color: #333;
        text-align: justify;
        word-break: break-all;
        line-height: 24px;
        margin-block: 8px;
    }
    .row_right_img{
        width: 100%;
        height: auto;
        display: block;
    }
    .detail_mask_block{
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0,0,0,.9);
        z-index: 100;
    }
    .detail_mask_close{
        width: 40px;
        height: 40px;
        position: absolute;
        right: 10px;
        top: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .detail_mask_show{
        width: 100%;
        position: absolute;
        left: 0;
        top: 60px;
        bottom: 0;
        overflow-y: scroll;
    }
</style>